<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left is-flex">
          <a class="nav-item is-hidden-tablet" @click="toggleSidebar({opened: !sidebar.opened})">
            <i class="fa fa-bars" aria-hidden="true" v-show="!sidebar.hidden"></i>
          </a>
          <div v-if="loggedUser" class="nav-item">
            <button class="button is-success is-outlined" :disabled="true">
              <span>{{loggedUser}}</span>
            </button>
            <button v-if="loggedUserState!='Активен'" class="button is-danger is-outlined" :disabled="true">
              <span>{{loggedUserState}}</span>
            </button>
          </div>

        </div>
        <div class="nav-center">
          <a class="nav-item hero-brand" href="/">
            <!-- <img src="~assets/logo.svg" :alt="pkginfo.description"> -->
            <tooltip :label="'beta'" placement="right" type="success" size="small" :no-animate="true" :always="true" :rounded="true">
              <div class="is-hidden-mobile">
                <span class="vue">{{appTitle}}</span> <strong class="admin">&nbsp;Личный Кабинет</strong>
              </div>
            </tooltip>
          </a>
        </div>
        <div class="nav-right is-flex">
          <a class="nav-item is-hidden-tablet" @click="toggleSidebar({opened: !sidebar.opened})">
            <i class="fa fa-bars" aria-hidden="true" v-show="!sidebar.hidden"></i>
          </a>

          <a  v-if="isLogged" :href="'#/users/'+loggedId" class="nav-item" tag="button">
            <button class="button is-light" style="width:100%">
              <span class="icon">
                <i class="fa fa-user-circle"></i>
              </span>
              <span>Профиль пользователя</span>
            </button>
          </a>
          <!--<router-link v-if="!isLogged" to="/login" class="nav-item">
            <button class="button is-light" style="width:100%">
              <span class="icon">
                <i class="fa fa-hand-o-right"></i>
              </span>
              <span>Вход</span>
            </button>
          </router-link>-->
          <a href="https://voicebot.doc.ivoice.online/" target="_blank" class="nav-item" tag="button">
            <button class="button is-light" style="width:100%">
              <span class="icon">
                <i class="fa fa-wikipedia-w"></i>
              </span>
              <span>Помощь</span>
            </button>
          </a>
          <a  v-if="isLogged" @click="logout" class="nav-item" tag="button">
            <button class="button is-light" style="width:100%">
              <span class="icon">
                <i class="fa fa-power-off"></i>
              </span>
              <span>Выход</span>
            </button>
          </a>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
import Tooltip from 'vue-bulma-tooltip'
import { mapGetters, mapActions } from 'vuex'

const APPCONFIG_API = '/api/appConfig'

export default {

  components: {
    Tooltip
  },

  props: {
    show: Boolean
  },

  computed: mapGetters({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    loggedUser: 'loggedUser',
    loggedUserState: 'loggedUserState',
    loggedId: 'loggedId',
    isLogged: 'isLogged'
  }),

  data () {
    return {
      appconfig: {},
      appTitle: ''
    }
  },

  created: function () {
    this.loadAppConfig()
  },

  methods: {
    ...mapActions([
      'toggleSidebar',
      'removeToken',
      'setLoggedRole',
      'setLoggedStatus',
      'setLoggedId',
      'setLoggedUser',
      'setLoggedUserState',
      'setPermissionMap',
      'setClientId'
    ]),
    logout () {
      clearInterval(this.$root.monitor)
      this.removeToken()
      this.setLoggedId(null)
      this.setLoggedUser('')
      this.setLoggedUserState('')
      this.setLoggedStatus(false)
      this.setLoggedRole('Anonymous')
      this.setPermissionMap('')
      this.setClientId(null)
      this.$router.push('/login')
    },
    prepareSecurityHeader() {
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    loadAppConfig () {
      this.$http.get(APPCONFIG_API, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.appconfig = response.data
          this.appTitle = this.appconfig.defaultAppTitle
          document.title = this.appTitle + ' - Личный Кабинет'
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.hero-brand {
  .vue {
    margin-left: 10px;
    color: rgb(54, 91, 172);
  }
  .admin {
    color: #28374B;
  }
}

</style>



// WEBPACK FOOTER //
// Navbar.vue?4bde6837